import { Card, Stack } from '@mui/material';
import {
    BulkActionsToolbar,
    BulkDeleteButton,
    BulkExportButton,
    CreateButton,
    ExportButton,
    ListToolbar,
    Pagination,
    Title,
    TopToolbar,
} from 'react-admin';
import { MemberListContent } from './MemberListContent';
import { MemberListFilter } from './MemberListFilter';
import { MemberSortButton } from './MemberSortButton';
import { memberExporter } from '../MemberExporter';
import { AntennaId } from '@wwf/sdk';

interface MemberListLayoutProps {
    antennaId?: AntennaId;
    disableSaveQuery?: boolean;
}

export const MemberListLayout = ({
    antennaId,
    disableSaveQuery,
}: MemberListLayoutProps) => {
    return (
        <Stack direction="row">
            <MemberListFilter
                disableSaveQuery={disableSaveQuery}
                sx={{ mt: 2 }}
                disableAntennaFilter={antennaId !== undefined}
            />
            <Stack sx={{ width: '100%' }}>
                <Title title={'member'} />
                <ListToolbar
                    actions={<MemberListActions antennaId={antennaId} />}
                />
                <BulkActionsToolbar>
                    <BulkExportButton exporter={memberExporter} />
                    <BulkDeleteButton />
                </BulkActionsToolbar>
                <Card>
                    <MemberListContent />
                </Card>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

interface MemberListActionsProps {
    antennaId?: string;
}

const MemberListActions = ({ antennaId }: MemberListActionsProps) => (
    <TopToolbar>
        <MemberSortButton />
        <ExportButton exporter={memberExporter} />
        <CreateButton
            variant="contained"
            label="New Member"
            resource="member"
            sx={{ marginLeft: 2 }}
            state={antennaId ? { antennaId } : undefined}
        />
    </TopToolbar>
);
